import Vue from 'vue'
import VueRouter from 'vue-router'
import privacy from '@/views/privacy.vue';
import userProtocol from '@/views/userProtocol.vue';
import sdk from '@/views/sdk/sdk_file.vue';
import service from '@/views/service/service.vue';
import enPrivacy from '@/views/enPrivacy.vue';
import enUserProtocol from '@/views/enUserProtocol.vue';
import jaPrivacy from '@/views/jaPrivacy.vue';
import jaUserProtocol from '@/views/jaUserProtocol.vue';
import koPrivacy from '@/views/koPrivacy.vue';
import koUserProtocol from '@/views/koUserProtocol.vue';
import ptPrivacy from '@/views/ptPrivacy.vue';
import ptUserProtocol from '@/views/ptUserProtocol.vue';
import esPrivacy from '@/views/esPrivacy.vue';
import esUserProtocol from '@/views/esUserProtocol.vue';
import dePrivacy from '@/views/dePrivacy.vue';
import deUserProtocol from '@/views/deUserProtocol.vue';
import ruPrivacy from '@/views/ruPrivacy.vue';
import ruUserProtocol from '@/views/ruUserProtocol.vue';
// import arPrivacy from '@/views/arPrivacy.vue';
// import arUserProtocol from '@/views/arUserProtocol.vue';
// import zhTWPrivacy from '@/views/zhTWPrivacy.vue';
// import zhTWUserProtocol from '@/views/zhTWUserProtocol.vue';
import frPrivacy from '@/views/frPrivacy.vue';
import frUserProtocol from '@/views/frUserProtocol.vue';
import itPrivacy from '@/views/itPrivacy.vue';
import itUserProtocol from '@/views/itUserProtocol.vue';

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/privacy',
		component: privacy,
		meta: {
			title: '隐私政策'
		}
	},
	{
		path: '/privacy',
		name: '隐私政策',
		component: privacy,
		meta: {
			title: '隐私政策'
		}
	},
	{
		path: '/userProtocol',
		name: '用户协议',
		component: userProtocol,
		meta: {
			title: '用户协议'
		}
	},
	{
		path: '/sdk/sdk_file',
		name: '第三方SDK说明',
		component: sdk,
		meta: {
			title: '第三方SDK说明'
		}
	},
	{
		path: '/service/service',
		name: '联通统一认证服务条款',
		component: service,
		meta: {
			title: '联通统一认证服务条款'
		}
	},
	// {
	// 	path: '/zhTWPrivacy',
	// 	name: '隱私政策',
	// 	component: zhTWPrivacy,
	// 	meta: {
	// 		title: '隱私政策'
	// 	}
	// },
	// {
	// 	path: '/zhTWUserProtocol',
	// 	name: '用戶協議',
	// 	component: zhTWUserProtocol,
	// 	meta: {
	// 		title: '用戶協議'
	// 	}
	// },
	{
		path: '/enPrivacy',
		name: 'Privacy',
		component: enPrivacy,
		meta: {
			title: 'Privacy'
		}
	},
	{
		path: '/enUserProtocol',
		name: 'UserProtocol',
		component: enUserProtocol,
		meta: {
			title: 'UserProtocol'
		}
	},
	{
		path: '/jaPrivacy',
		name: 'プライバシーポリシー',
		component: jaPrivacy,
		meta: {
			title: 'プライバシーポリシー'
		}
	},
	{
		path: '/jaUserProtocol',
		name: 'ユーザープロトコル',
		component: jaUserProtocol,
		meta: {
			title: 'ユーザープロトコル'
		}
	},
	{
		path: '/koPrivacy',
		name: '개인 정보 정책',
		component: koPrivacy,
		meta: {
			title: '개인 정보 정책'
		}
	},
	{
		path: '/koUserProtocol',
		name: '사용자 계약',
		component: koUserProtocol,
		meta: {
			title: '사용자 계약'
		}
	},
	{
		path: '/ptPrivacy',
		name: 'Política de Privacidade',
		component: ptPrivacy,
		meta: {
			title: 'Política de Privacidade'
		}
	},
	{
		path: '/ptUserProtocol',
		name: 'Contrato de Usuário',
		component: ptUserProtocol,
		meta: {
			title: 'Contrato de Usuário'
		}
	},
	{
		path: '/esPrivacy',
		name: 'Política de privacidad',
		component: esPrivacy,
		meta: {
			title: 'Política de privacidad'
		}
	},
	{
		path: '/esUserProtocol',
		name: 'Acuerdo de usuario',
		component: esUserProtocol,
		meta: {
			title: 'Acuerdo de usuario'
		}
	},
	{
		path: '/dePrivacy',
		name: 'Datenschutz-Politik',
		component: dePrivacy,
		meta: {
			title: 'Datenschutz-Politik'
		}
	},
	{
		path: '/deUserProtocol',
		name: 'Nutzungsvereinbarung',
		component: deUserProtocol,
		meta: {
			title: 'Nutzungsvereinbarung'
		}
	},
	{
		path: '/ruPrivacy',
		name: 'Политика конфиденциальности',
		component: ruPrivacy,
		meta: {
			title: 'Политика конфиденциальности'
		}
	},
	{
		path: '/ruUserProtocol',
		name: 'Пользовательское соглашение',
		component: ruUserProtocol,
		meta: {
			title: 'Пользовательское соглашение'
		}
	},
	// {
	// 	path: '/arPrivacy',
	// 	name: 'سياسة الخصوصية',
	// 	component: arPrivacy,
	// 	meta: {
	// 		title: 'سياسة الخصوصية'
	// 	}
	// },
	// {
	// 	path: '/arUserProtocol',
	// 	name: 'اتفاقية المستخدم',
	// 	component: arUserProtocol,
	// 	meta: {
	// 		title: 'اتفاقية المستخدم'
	// 	}
	// },
	{
		path: '/frPrivacy',
		name: 'Charte de confidentialité',
		component: frPrivacy,
		meta: {
			title: 'Charte de confidentialité'
		}
	},
	{
		path: '/frUserProtocol',
		name: 'Contrat d\'utilisation',
		component: frUserProtocol,
		meta: {
			title: 'Contrat d\'utilisation'
		}
	},
	{
		path: '/itPrivacy',
		name: 'Informativa sulla privacy',
		component: itPrivacy,
		meta: {
			title: 'Informativa sulla privacy'
		}
	},
	{
		path: '/itUserProtocol',
		name: 'Contratto d\'uso',
		component: itUserProtocol,
		meta: {
			title: 'Contratto d\'uso'
		}
	},
]

const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	console.log(to.meta.title)
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
})
export default router
